import React, { useState } from 'react';
import { View, Text } from 'react-native';

import {
  DownloadButton,
  downloadReport,
} from 'app/src/elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { saleOptions, paddleServiceOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const SellerConfirmationReport = ({ data }) => {
  const [paddleServiceId, setPaddleServiceId] = useState();
  const [saleId, setSaleId] = useState();
  const [originalIfFor, setOriginalIfFor] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'seller-confirmation-report',
      params: {
        'paddle-service-id': paddleServiceId,
        'sale-id': saleId,
        'original-if-for': originalIfFor,
      }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Seller Confirmation Report</Text>

      <Text style={styles.label}>Sale (optional):</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />

      <Text style={styles.label}>Paddle Service  (optional):</Text>
      <SearchableSelect
        placeholder="Select Paddle Service"
        options={paddleServiceOptions(data)}
        value={paddleServiceId}
        onChange={setPaddleServiceId}
      />

      <Text style={styles.label}>Show Original If Bid For:</Text>
      <select
        style={styles.select}
        onChange={(e) => setOriginalIfFor(e.target.value)}
      >
        <option value="all">All Assets</option>
        <option value="sold">Only Sold Assets</option>
      </select>

      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default SellerConfirmationReport;
